import React from 'react';
import { Link2, SlidersHorizontal, Download, X } from 'lucide-react';
import { Button } from '../ui/button';

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
 
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose}></div>
       
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
       
        <div className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-gray-900" id="modal-title">
                How It Works
              </h3>
              <Button
                onClick={onClose}
                aria-label="Close how TopClip works"
                variant="ghost"
                size="sm"
                className="rounded-full p-2 hover:bg-gray-100 transition-colors"
              >
                <X className="w-6 h-6 text-gray-400" />
              </Button>
            </div>
           
            <div className="space-y-8 sm:space-y-12">
              {/* Step 1 */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center">
                    <Link2 className="w-8 h-8 text-blue-600" />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">1. Paste a YouTube link</h4>
                  <p className="text-gray-600 leading-relaxed">
                    Add one landscape YouTube video between 5 and 90 minutes. TopClip validates the source and your signed-in credit balance before generation.
                  </p>
                </div>
              </div>
             
              {/* Step 2 */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center">
                    <SlidersHorizontal className="w-8 h-8 text-purple-600" />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">2. Choose clip settings</h4>
                  <p className="text-gray-600 leading-relaxed">
                    Pick the number of clips you want produced, or let TopClip's AI choose the optimal number for you. Then pick your desired clip length and caption style, and add catchy AI titles.
                  </p>
                </div>
              </div>
             
              {/* Step 3 */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center">
                    <Download className="w-8 h-8 text-green-600" />
                  </div>
                </div>
                <div className="flex-1">
                  <h4 className="text-xl font-semibold text-gray-900 mb-2">3. Get your clips!</h4>
                  <p className="text-gray-600 leading-relaxed">
                    TopClip works its magic to create unique, engaging clips that are built to go viral. Watch and download your finished clips from My Clips.
                  </p>
                </div>
              </div>
            </div>
           
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="flex justify-center">
                <Button
                  onClick={onClose}
                  className="bg-[#3870FF] hover:bg-[#3870FF]/90 text-white px-8 py-4 rounded-full font-semibold min-w-[180px]"
                >
                  Back to Homepage
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
